import { MouseEvent, ReactNode } from 'react';
import StyledButton from '../styled/StyledButton';

interface ConfirmationModalProps {
  closeModal: () => void;
  message: string;
  title: string;
  icon: ReactNode;
  goBackTitle: string;
  goBackAction: () => void;
  cancel?: {
    title: string;
  };
}

const ConfirmationModal = ({
  closeModal,
  message,
  icon,
  title,
  goBackAction,
  goBackTitle,
  cancel,
}: ConfirmationModalProps) => {
  const handleDialogClick = (event: MouseEvent<HTMLDialogElement>) => {
    if (event.target === event.currentTarget) {
      closeModal();
    }
  };

  return (
    <dialog
      open
      onClick={handleDialogClick}
      className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center overflow-auto bg-black/50"
    >
      <div className="flex flex-col justify-between min-w-96 gap-8 p-6 border rounded-md border-gray-200 bg-white">
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center justify-center size-10 rounded-3xl bg-brand-50">
            {icon}
          </div>
          <h1 className="text-lg leading-6 font-semibold text-gray-950">
            {title}
          </h1>
          <p className="text-sm leading-6 text-gray-800 max-w-96 text-center">
            {message}
          </p>
        </div>
        {cancel && (
          <StyledButton
            variant="outlined"
            title={cancel.title}
            className="text-gray-800 border-gray-300 w-full"
            onClick={closeModal}
          />
        )}
        <StyledButton
          variant="outlined"
          title={goBackTitle}
          className="text-gray-800 border-gray-300 w-full"
          onClick={goBackAction}
        />
      </div>
    </dialog>
  );
};

export default ConfirmationModal;
